module.exports = __webpack_public_path__ + "img/lsu_tiger.ba9f62f7.svg";